import { PartialObject } from 'lodash';
import { InsuranceNode, ProviderCertificationNode } from './../../../generated/webapp_gql';

import {
    CareRecommendationNode,
    CompanyAdditionalBenefitNode,
    CrisisProviderCompanyAssignmentNode,
    CrisisProviderCountryAssignmentNode,
} from 'src/generated/webapp_gql';
import { ValidateTokenData } from 'src/modules/auth/models/auth';

export interface RegisteredUserInfo {
    firstName: string;
    id: number;
    uuid: string;
    lastName: string;
    email: string;
}

export interface UserProfileSettingsDetails extends PartialObject<UserDetails> {
    avatarFile: File | null;
}

export enum Role {
    MEMBER = 'MEMBER',
    COACH = 'COACH',
    SYSTEM_ADMINISTRATOR = 'SYSTEM_ADMINISTRATOR',
}

export enum ProviderType {
    COACH = 'Coach',
    THERAPIST = 'Therapist',
    MENTAL_HEALTH_COACH = 'Mental_Health_Coach',
}

export enum SOURCE_TYPES {
    PRE_ONBOARDING = 'Pre Onboarding',
    POST_ONBOARDING = 'Post Onboarding',
    HOME_PAGE = 'Home Page',
    SETTINGS = 'Settings',
    PHQ_9 = 'PHQ-9',
}
export interface CrisisEvent {
    platform: string;
    source: string;
}

export interface UserDetails extends RegisteredUserInfo {
    avatar: string | null;
    company: string;
    companyUuid: string;
    username: string;
    zipCode: string;
    state: string;
    mailingAddress: string;
    phoneNumber: string;
    mobileAppUsed: boolean; // TODO(Michal): Make sure that this field gets added to the backend
    birthDate: string | null;
    newEmailAddressNotConfirmed: string | null;
    localTimezone: string;
    languagePreferences: string[];
    parentUuid: string | null;
    country: string;
    availability: string[];
    city: string;
    role: Role;
    defaultVisitDuration: number;
    eligiblePersonEmail: string | null;
    isActiveCobraRifMember: boolean;
    emailConfirmed: boolean;
    joinedAt: string;
    races?: string[];
    careRecommendations: CareRecommendationNode[];
    registrationSource: string;
    hpiEligibilityStatus: boolean;
    hpiMemberInsurance: InsuranceNode | null;
}

export interface UpdateUserInfoPayload extends UserDetails {
    password: string;
    oldPassword: string;
}

export interface ChangePasswordPayload {
    currentPassword: string;
    newPassword: string;
    newPasswordConfirmation: string;
}

export interface UserState extends UserDetails {
    inviteDependentModalVisible: boolean;
    companyAdditionalBenefits: CompanyAdditionalBenefitNode[];
    providerCertifications: ProviderCertificationNode[];
    crisisProviderCompanyAssignments: CrisisProviderCompanyAssignmentNode[];
    crisisProviderCountryAssignments: CrisisProviderCountryAssignmentNode[];
}

export type NewEmailAddressConfirmTokenData = ValidateTokenData;
